"use client";

import { c as _c } from "react/compiler-runtime";
import { BuyerDetails, getBuyerData } from "@/utils/get-buyer-data";
import React from "react";
import { useAuth } from "./use-auth";
export interface BuyerActions {
  shortlistUnits: string[];
  requestVisitUnits: string[];
  shortlistProjects: string[];
  requestVisitProjects: string[];
}
export interface BuyerRequestContextValue {
  data?: BuyerDetails | null;
  error?: string | null;
  actions: BuyerActions;
  refetch: (_arg0?: string) => Promise<void>;
  setActions: (actions: BuyerActions) => void;
}
export const BuyerRequestContext = React.createContext<BuyerRequestContextValue | null>(null);
export const BuyerRequestProvider: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(17);
  const {
    children
  } = t0;
  const {
    user
  } = useAuth();
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      shortlistUnits: [],
      requestVisitUnits: [],
      shortlistProjects: [],
      requestVisitProjects: []
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [actions, setActions] = React.useState(t1);
  let t2;
  if ($[1] !== user?.groups) {
    t2 = async buyerId => {
      buyerId = buyerId ?? user?.groups.find(_temp)?.id;
      if (buyerId) {
        ;
        try {
          const response = await getBuyerData({
            id: buyerId
          });
          setData(response.data);
          setError(response.error);
        } catch (t3) {
          const error_0 = t3;
          if (error_0 instanceof Error) {
            setError(error_0.message);
          } else {
            setError("An error occurred");
          }
        }
      }
    };
    $[1] = user?.groups;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  user?.groups;
  const refetch = t2;
  let t3;
  if ($[3] !== refetch || $[4] !== user?.groups) {
    t3 = () => {
      if (user?.groups) {
        refetch();
      } else {
        setData(null);
      }
    };
    $[3] = refetch;
    $[4] = user?.groups;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = user?.groups;
  let t5;
  if ($[6] !== refetch || $[7] !== t4) {
    t5 = [refetch, t4];
    $[6] = refetch;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  React.useEffect(t3, t5);
  let t6;
  if ($[9] !== actions || $[10] !== data || $[11] !== error || $[12] !== refetch) {
    t6 = {
      data,
      error,
      refetch,
      actions,
      setActions
    };
    $[9] = actions;
    $[10] = data;
    $[11] = error;
    $[12] = refetch;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const contextValue = t6;
  let t7;
  if ($[14] !== children || $[15] !== contextValue) {
    t7 = <BuyerRequestContext.Provider value={contextValue}>{children}</BuyerRequestContext.Provider>;
    $[14] = children;
    $[15] = contextValue;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export const useBuyerRequestContext = () => {
  const context = React.useContext(BuyerRequestContext);
  if (context === null) {
    throw new Error("useBuyerRequestContext must be used within a BuyerRequestProvider");
  }
  return context;
};
function _temp(group) {
  return group.relationship === "buyer";
}